// extracted by mini-css-extract-plugin
export default {"headerBar":"Question_headerBar__RNuC5"};